import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.707 3.293A1 1 0 0110.414 3h3.172a1 1 0 01.707.293L15 4h3a1 1 0 110 2H6a1 1 0 010-2h3l.707-.707zM7 7H5.913l.09 1.083.924 11.083A2 2 0 008.92 21h6.16a2 2 0 001.993-1.834l.924-11.083.09-1.083H7zm1.92 12L8.087 9h7.826l-.833 10H8.92z",
      fill: "#2d6ded"
    }
  )
), a = t;
export {
  a as default
};
